<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2020-04-24 17:09:42
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-07-19 13:38:13
 * @Description: 
 * @FilePath: /src/page/movie/components/item.vue
-->

<template>
    <div class="line">
        <div
            class="img-box"
            v-for="(item, index) in data"
            @click="clickItem(item, index)"
            :class="[
                { 'show-border': item && item.middle },
                { love1: item && item.love == 1 },
                { love2: item && item.love == 2 },
            ]"
            :key="index"
        >
            <template v-if="item && item.love != 2">
                <img
                    class="img"
                    :src="
                        require('@/assets/icons/' +
                            (item.status == 'LK'
                                ? 'select'
                                : item.select
                                ? 'my-select'
                                : 'default-' +
                                  (item.areaPriceIndex > 2 ? 2 : item.areaPriceIndex)) +
                            (item.love == 1
                                ? '-love-left'
                                : item.love == 2
                                ? '-love-right'
                                : '-default') +
                            '.png')
                    "
                    alt=""
                />
            </template>
            <div class="none-bg" v-if="!item"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['data', 'row', 'middleColumn'],
    methods: {
        // 点击选座
        clickItem(item, index) {
            const row = this.row;
            const column = index;
            this.$emit('selectSeat', item, row, column);
            this.$forceUpdate();
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
.line {
    display: flex;
    flex-direction: row;
    // .show-border {
    //     &:after {
    //         content: ' ';
    //         position: absolute;
    //         top: .pxToRem(4) [];
    //         left: .pxToRem(-4) [];
    //         bottom: 0;
    //         border-left: 1px dotted #9f9f9f;
    //         width: 1px;
    //     }
    //     &.love2 {
    //         &::after {
    //             left: 0;
    //         }
    //     }
    // }
    .img-box {
        margin-right: .pxToRem(10) [];
        padding-bottom: .pxToRem(10) [];
        width: .pxToRem(48) [];
        height: .pxToRem(46) [];
        position: relative;
        &.love1 {
            width: .pxToRem(106) [];
            height: .pxToRem(46) [];
            .img {
                width: .pxToRem(106) [];
                height: .pxToRem(46) [];
            }
        }
        &.love2 {
            width: 0;
            height: .pxToRem(46) [];
        }
        &.love1 {
            margin-right: 0 !important;
        }
        .img {
            width: .pxToRem(48) [];
            height: .pxToRem(46) [];
        }
        // .border {
        //     width: .pxToRem(1) [];
        //     border-left: .pxToRem(1) [] dotted #9f9f9f;
        //     position: absolute;
        //     left: .pxToRem(-10) [];
        //     top: 0;
        //     bottom: 0;
        // }
    }
    .none-bg {
        width: .pxToRem(50) [];
    }
}
</style>
